/**
 * Nhãn dùng chung cho MỌI nút xuất dữ liệu.
 *
 * Trước đây mỗi màn hình tự đặt khóa riêng (`piWorkspace.exportPage`,
 * `quotationWorkspace.exportPage`, `productList.exportAll`…) nên cùng một hành
 * động lại đọc ra ba câu khác nhau tùy trang. Một bộ nhãn, một hành vi.
 */
export const dataExportEn = {
  title: "Export",
  scope: "What to export",
  page: "Current page ({{count}} rows)",
  filtered: "All rows matching the current filter ({{count}})",
  format: "File format",
  xlsx: "Excel (.xlsx)",
  xlsxHint: "Opens directly in Excel: header row stays visible, filters are ready, numbers are real numbers.",
  csv: "CSV (.csv)",
  csvHint: "Plain text for Google Sheets, accounting software or another system.",
  note: "Same columns in both formats. Amounts are plain numbers so formulas work, and the currency is a separate column.",
  prepare: "Prepare file",
  download: "Download {{count}} rows",
  preparing: "Preparing… {{count}} of {{total}}",
  verifying: "Checking the data has not changed… {{count}} of {{total}}",
  changed:
    "The data changed while the file was being prepared, so it would have been incomplete. Please export again.",
  tooMany: "Too many rows to export in one file. Narrow the filter and try again.",
  failed: "Could not export. Please try again.",
  empty: "There is nothing to export.",
  pdfHint: "Need a PDF? Print, then choose “Save as PDF” as the destination.",
};

export const dataExportVi = {
  title: "Xuất dữ liệu",
  scope: "Xuất phần nào",
  page: "Trang hiện tại ({{count}} dòng)",
  filtered: "Toàn bộ kết quả của bộ lọc đang mở ({{count}})",
  format: "Định dạng tệp",
  xlsx: "Excel (.xlsx)",
  xlsxHint: "Mở thẳng bằng Excel: dòng tiêu đề đứng yên khi cuộn, có sẵn bộ lọc, số là số thật.",
  csv: "CSV (.csv)",
  csvHint: "Văn bản thuần để dán vào Google Sheets, phần mềm kế toán hoặc hệ thống khác.",
  note: "Hai định dạng cùng một bộ cột. Tiền là số trần để công thức chạy được, loại tiền nằm ở cột riêng.",
  prepare: "Chuẩn bị tệp",
  download: "Tải {{count}} dòng",
  preparing: "Đang chuẩn bị… {{count}} / {{total}}",
  verifying: "Đang đối chiếu xem dữ liệu có đổi không… {{count}} / {{total}}",
  changed:
    "Dữ liệu vừa thay đổi trong lúc chuẩn bị tệp, nên tệp sẽ không đủ. Vui lòng xuất lại.",
  tooMany: "Quá nhiều dòng cho một tệp. Hãy lọc hẹp lại rồi xuất.",
  failed: "Không xuất được. Vui lòng thử lại.",
  empty: "Không có dòng nào để xuất.",
  pdfHint: "Cần PDF? Bấm In rồi chọn “Save as PDF / Lưu thành PDF” ở mục máy in.",
};

export const dataExportZh = {
  title: "导出数据",
  scope: "导出范围",
  page: "当前页（{{count}} 行）",
  filtered: "符合当前筛选条件的全部数据（{{count}}）",
  format: "文件格式",
  xlsx: "Excel (.xlsx)",
  xlsxHint: "直接以 Excel 打开：标题行固定、已设筛选、数字为真正的数值。",
  csv: "CSV (.csv)",
  csvHint: "纯文本，适合粘贴到 Google 表格、会计软件或其他系统。",
  note: "两种格式字段相同。金额为纯数字以便用于公式计算，币种单独成列。",
  prepare: "准备文件",
  download: "下载 {{count}} 行",
  preparing: "准备中… {{count}} / {{total}}",
  verifying: "正在确认数据未变动… {{count}} / {{total}}",
  changed: "准备文件期间数据已变动，导出结果将不完整。请重新导出。",
  tooMany: "数据行过多，无法一次导出。请缩小筛选范围后再试。",
  failed: "无法导出，请重试。",
  empty: "没有可导出的数据。",
  pdfHint: "需要 PDF？请按打印，并将目标打印机选为“另存为PDF”。",
};
